module.exports = __webpack_public_path__ + "681412f1ccb18269b678008fd268b08c.glb";